import React from 'react';
import { object } from 'prop-types';
import { PrepareRelayContextProvider } from '../PrepareRelayContextProvider/PrepareRelayContextProvider';
import Footer from '../Footer/Footer';

const FooterRenderer = props => {
    const { environment, initialVariables, query } = props;

    return (
        <PrepareRelayContextProvider
            environment={environment}
            query={query}
            variables={initialVariables}
            render={({ props: rendererProps }) => <Footer {...rendererProps} />}
        />
    );
};

FooterRenderer.propTypes = {
    environment: object,
    initialVariables: object,
    query: object,
};

export default FooterRenderer;
